
import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { LinkPrimaryButton } from '../../uiComponents/input/Buttons';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Loading } from '../../uiComponents/Loading';
import { EksternBruger } from '../../models/EksternBruger';
import NotificationModule from '../../uiComponents/layout/Notification';
import { Icon } from '../../uiComponents/Icon';

interface EksternAdgangListProps {
}

interface EksternAdgangListState {
    eksterneBrugere: EksternBruger[];
}

class EksternAdgangList extends React.Component<EksternAdgangListProps, EksternAdgangListState> {
    constructor(props: EksternAdgangListProps) {
        super(props);

        this.state = { eksterneBrugere: [] };
        this.menuFormatter = this.menuFormatter.bind(this);
        this.sletBrugerFormatter = this.sletBrugerFormatter.bind(this);
    }

    componentDidMount() {
        var self = this;
        var result = createApiCaller().getEksterneBrugere();
        result.then(function (response: EksternBruger[]) {
            self.setState({ eksterneBrugere: response });
        });
    }

    menuFormatter(cell: any, row: any) {
        const btnText = row.erGensendt ? 'Gensendt' : 'Gensend invitation';
        const isSubmitting = row.isSubmitting;
        const classes = row.erGensendt || isSubmitting ? 'btn-disabled' : '';

        return row.erAktiv ? '' : (
                <Button disabled={row.erGensendt || isSubmitting} buttonType='secondary' className={classes} onClick={() => this.gensendInvitation(row)}>
                    {isSubmitting ? 'Vent...' : btnText}
                </Button>
            );
    }

    gensendInvitation(row: any) {
        const self = this;
        const { eksterneBrugere } = self.state;
        const eksternBruger = eksterneBrugere.filter(bruger => {
                return bruger.email === row.email;
            })[0];

        const indexOfBruger = eksterneBrugere.indexOf(eksternBruger);
        eksternBruger.isSubmitting = true;
        eksterneBrugere[indexOfBruger] = eksternBruger;
        self.setState({ eksterneBrugere: eksterneBrugere });

        var result = createApiCaller().gensendEksternBrugerInvitation(row.email);
        result.then(function (response: any) {
            NotificationModule.showSuccess('', 'Der blev gensendt en invitation til ' + row.email, true);

            eksternBruger.isSubmitting = false;
            eksternBruger.erGensendt = true;
            eksterneBrugere[indexOfBruger] = eksternBruger;

            self.setState({ eksterneBrugere: eksterneBrugere });
        });
    }

    sletBruger(row: any) {
        const self = this;
        
        var deleteResult = createApiCaller().deleteEksternBruger(row.id);
        deleteResult.then(function (deleteResponse: any) {
            NotificationModule.showSuccess('', 'Brugeren blev slettet', true);

            var result = createApiCaller().getEksterneBrugere();
            result.then(function (response: EksternBruger[]) {
                self.setState({ eksterneBrugere: response });
            });
        });
    }

    aktiveretFormatter(cell: any, row: any) {
        const erAktiv = row.erAktiv;
        return erAktiv ? 'Ja' : 'Nej'; 
    }

    navnFormatter(cell: any, row: any) {
        const navn = row.navn;
        return navn ? navn : 'Ikke valgt';
    }

    sletBrugerFormatter(cell: any, row: any) {
        return (
            <Icon title={'Slet'} name={'remove'} onClick={() => this.sletBruger(row)} className='ekstern-ekstern-fjern' />);
    }

    render() {
        const buttons = <LinkPrimaryButton url={'/eksternadgang/ny'} text={'Ny ekstern bruger'} />;
        const eksterneBrugere = this.state.eksterneBrugere === undefined ? [] : this.state.eksterneBrugere;
        const headerText = eksterneBrugere.length === 1 ? ' ekstern bruger' : ' eksterne brugere';

        return (
            <PageWrapper>
                <PageTitle title='Eksterne brugere' />
                <ContentWrapper>
                    <Loading isLoading={this.state.eksterneBrugere === undefined}>
                        <SectionGroup header={eksterneBrugere.length + headerText} buttons={buttons}>
                            <Section fullWidth={true}>
                                <Table data={eksterneBrugere} pagination={true} emptyText='Ingen eksterne brugere'>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn dataField='navn' className='first' columnClassName='first' dataFormat={this.navnFormatter} dataSort={true}>Navn</TableHeaderColumn>
                                    <TableHeaderColumn dataField='email' dataSort={true}>Email</TableHeaderColumn>
                                    <TableHeaderColumn dataField='kommendeKonkurrencer' dataSort={true}>Konkurrencer</TableHeaderColumn>
                                    <TableHeaderColumn dataField='erAktiv' dataFormat={this.aktiveretFormatter} dataSort={true}>Aktiveret</TableHeaderColumn>
                                    <TableHeaderColumn width='210' dataFormat={this.menuFormatter} className='table-menu' columnClassName='table-menu' />
                                    <TableHeaderColumn width='50' dataFormat={this.sletBrugerFormatter} className='table-menu' columnClassName='table-menu' />
                                </Table>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default EksternAdgangList;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/eksternAdgang/EksternAdgangList.tsx